import { Button, Col, Form, notification, Switch, Row } from "antd"
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../../../app/store"
import { EditableList } from "../../../../../compnents/list/EditableList"
import { getFieldSettingList, saveFieldSettingList, restoreDefaultSetting } from "../FieldSettingSlice"
import { unwrapResult } from "@reduxjs/toolkit"
import { selectEdition, selectTenantCategory } from "../../../../../app/applicationSlice"

const BLFeildMap = {
  'YYSZ': [
    { key: 'name', label: '患者姓名', isRequired: true, isNotModified: true, rid: 'name' },
    { key: 'sex', label: '性别', isRequired: true, isNotModified: true, rid: 'sex' },
    { key: 'age', label: '年龄', isRequired: true, isNotModified: true, rid: 'age' },
    { key: 'idCardNumber', label: '身份证号', isRequired: false, rid: 'idCardNumber' },
    { key: 'companyName', label: '工作单位', isRequired: false, rid: 'companyName' },
    { key: 'phone', label: '联系方式', isRequired: false, rid: 'phone' },
    { key: 'area', label: '家庭地区', isRequired: false, rid: 'area' },
    { key: 'address', label: '详细地址', isRequired: false, rid: 'address' },
    { key: 'emergencyContactName', label: '紧急联系人', isRequired: false, rid: 'emergencyContactName' },
    { key: 'emergencyContactPhone', label: '紧急联系方式', isRequired: false, rid: 'emergencyContactPhone' },
    { key: 'patientSource', label: '患者来源', isRequired: false, rid: 'patientSource' },
    { key: 'appointmentDepartmentId', label: '医生科室', isRequired: true, isNotModified: true, rid: 'appointmentDepartmentId' },
    { key: 'appointmentDoctorId', label: '医生', isRequired: true, isNotModified: true, rid: 'appointmentDoctorId' },
    { key: 'appointmentType', label: '预约方式', isRequired: false, rid: 'appointmentType' },
    { key: 'receiveTag', label: '接诊类型', isRequired: true, isNotModified: true, rid: 'receiveTag' },
    { key: 'appointmentDate', label: '预约日期', isRequired: true, isNotModified: true, rid: 'appointmentDate' },
    { key: 'workTime', label: '预约时间', isRequired: true, isNotModified: true, rid: 'workTime' },
    { key: 'appointmentItem', label: '预约项目', isRequired: false, rid: 'appointmentItem' },
    { key: 'remark', label: '预约备注', isRequired: false, rid: 'remark' },
  ]?.map((v: any, index: any) => {
    return {
      ...v, order: index + 1
    }
  }),
  'KQYYSZ': [
   { key: 'name', label: '患者姓名', isRequired: true, isNotModified: true, rid: 'name' },
    { key: 'sex', label: '性别', isRequired: true, isNotModified: true, rid: 'sex' },
    { key: 'age', label: '年龄', isRequired: true, isNotModified: true, rid: 'age' },
    { key: 'phone', label: '联系方式', isRequired: false, rid: 'phone' },
    { key: 'appointmentDepartmentId', label: '医生科室', isRequired: true, isNotModified: true, rid: 'appointmentDepartmentId' },
    { key: 'appointmentDoctorId', label: '医生', isRequired: true, isNotModified: true, rid: 'appointmentDoctorId' },
    { key: 'appointmentType', label: '预约方式', isRequired: false, rid: 'appointmentType' },
    { key: 'receiveTag', label: '接诊类型', isRequired: true, isNotModified: true, rid: 'receiveTag' },
    { key: 'appointmentDate', label: '预约日期', isRequired: true, isNotModified: true, rid: 'appointmentDate' },
    { key: 'workTime', label: '预约时间', isRequired: true, isNotModified: true, rid: 'workTime' },
    { key: 'appointmentItem', label: '预约项目', isRequired: false, rid: 'appointmentItem' },
    { key: 'remark', label: '预约备注', isRequired: false, rid: 'remark' },
  ]
}

export const AppointmentSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()
  const [form] = Form.useForm()

  const hisVersion = useSelector(selectEdition)

  const [buttonLoading, setButtonLoading] = useState(false)

  const [tableLoading, setTableLoading] = useState(false)

  const [selectedType, setSelectedType] = useState<string>(hisVersion == 1 ? 'KQYYSZ' : 'YYSZ')

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  useEffect(() => {
    if (props?.selectedTab == 'A4') {
      getPage(selectedType)
    }
  }, [props?.selectedTab])


  // 恢复默认设置按钮点击事件

  const restoreDefaultSettingBtnClick = () => {
    dispatch(restoreDefaultSetting({
      configType: 1,
      functionType: 4,
      templateType: selectedType,
    }))
      .then(() => {
        getPage(selectedType)
      })
      .catch((err) => {
        setTableLoading(false)
      })
  }


  const getPage = (templateType: string) => {
    setTableLoading(true)
    dispatch(getFieldSettingList({
      functionType: 4,
      templateType: templateType || selectedType,
    }))
      .then(unwrapResult)
      .then((res) => {
        if (res.length === 0) {
          const feilds = BLFeildMap[templateType as keyof typeof BLFeildMap]
          setPage({
            total: feilds.length,
            items: feilds,
          })
          setTableLoading(false)
          return
        } else {
          // 从后端获取的字段数据
          const backendFields = res[0].fields

          const defaultFields = BLFeildMap[templateType as keyof typeof BLFeildMap]

          const mergedFields = backendFields?.map((field: any) => {
            const defaultField = defaultFields?.find((df: any) => df.key == field.key)
            return {
              ...field,
              key: defaultField?.key || field.key,
              rid: defaultField?.key || field.key, // 补充rid字段，作为拖拽唯一ID
              isRequired: Boolean(field.isRequired),
              order: field.order || 1,
            }
          })
          setPage({
            total: mergedFields?.length,
            items: mergedFields,
          })
          setTableLoading(false)
        }
      })
      .catch((err) => {
        setTableLoading(false)
      })
  }

  return (
    <div style={{ height: '100%' }}>
      {/* <div style={{ margin: '0 0 6px 0' }}>{tips}</div> */}
      <div style={{
        height: 'calc(100% - 60px)',
        borderRadius: '8px',
      }}>
        <Form
          style={{ height: '100%' }}
          form={form}
          autoComplete='off'
          onFinish={() => {
            setButtonLoading(true)
            dispatch(
              saveFieldSettingList({
                configType: 1,
                functionType: 4,
                templateType: selectedType,
                fields: page.items,
              })
            )
              .then(unwrapResult)
              .then((val) => {
                notification.success({
                  message: '设置成功',
                })
                form.resetFields()
                getPage(selectedType)
              })
              .finally(() => {
                setButtonLoading(false)
              })
          }}
        >
          <div style={{ height: 'calc(100% - 10px)', paddingBottom: '20px', overflowY: 'auto' }}>
            <Row>
              <Col span={18}>
                <EditableList
                  loading={tableLoading}
                  rowKey={(record: any) => record.rid} // 确保rowKey和拖拽ID一致
                  dataSource={page.items} // 替换page属性为标准dataSource（适配antd Table）
                  bordered={true}
                  pagination={false}
                  // scroll={{ y: 1000, x: '100%' }}
                  columns={[
                    {
                      title: '序号',
                      key: 'no',
                      align: 'center',
                      width: '5rem',
                      fixed: 'left',
                      render: (_1, _2, i) => `${i + 1}`,
                    },
                    {
                      title: '患者字段',
                      dataIndex: "label",
                      key: "label",
                      align: "left",
                      width: '24rem',
                      fixed: 'left',
                      render: function labelElement(_, t) {
                        return (
                          <>
                            <span>{t.label}</span>
                            {/* {hisVersion == 1 ? '' :
                              // 身高、体重、腰围、邮箱地址、微信号、职业、婚姻状况
                              (t?.key == 'height' || t?.key == 'weight' || t?.key == 'waistline' || t?.key == 'emailAddress' || t?.key == 'wechat' || t?.key == 'job' || t?.key == 'maritalStatus' ?
                                <span style={{ color: '#999999', fontSize: '12px' }}>（只作用于新增/编辑患者）</span> : <></>)
                            } */}

                          </>
                        )
                      },
                    },
                    {
                      title: '是否必填',
                      dataIndex: "isRequired",
                      key: "isRequired",
                      align: "center",
                      width: '12rem',
                      fixed: 'right',
                      render: function action(_, t, index) {
                        return (
                          <Switch
                            checkedChildren='开启'
                            unCheckedChildren='关闭'
                            checked={t.isRequired}
                            disabled={t.isNotModified}
                            onChange={(checked) => {
                              if (t.isNotModified) {
                                return
                              }
                              const newItems = [...page.items]
                              newItems[index] = {
                                ...newItems[index],
                                isRequired: checked
                              }
                              setPage({ ...page, items: newItems })
                            }}
                          />
                        )
                      },
                    },
                  ]}
                />
              </Col>
            </Row>
          </div>
          <Row style={{ paddingTop: '10px' }}>
            <Col span={12}>
              <Button
                htmlType='button'
                onClick={() => {
                  restoreDefaultSettingBtnClick()
                }}
                style={{ float: 'right', marginRight: '10px' }}
              >
                恢复默认设置
              </Button>
            </Col>
            <Col span={12}>
              <Button
                loading={buttonLoading}
                type='primary'
                htmlType='submit'
                style={{ float: 'left' }}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}